import {Component, Input} from "@angular/core";
import {PortableDevice} from "../json/portable-device";

@Component({
	selector: "portable-registration-device-info",
	template: `
		<div class="warrantyregistration_deviceinfo">
			<!---------- IMAGE ---------->
			<image-container class="warrantyregistration_deviceinfo_image"
							 [width]="100"
							 [height]="100"
							 [src]="device.imageLink"
							 [alt]="device.productName"></image-container>

			<!---------- TEXT ---------->
			<div class="warrantyregistration_deviceinfo_text">
				<p>
					<strong>{{device.productName}}</strong><br>
					Serial Number: {{device.serialNumber}}<br>
					Part Number: {{device.partNumber}}<br>
					Unit ID: {{device.unitId}}<br>
					Source: {{device.source}}
				</p>
			</div>
		</div>
	`
})
export class PortableDeviceInfo {
	@Input() device: PortableDevice;
}
